import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { actions } from 'store/newDocumentStore';

import DocumentLoader from 'routes/Documents/containers/DocumentLoaderContainer';
import DocumentProvider from 'routes/Documents/containers/DocumentProvider';

import Lifestyle from '../components/Lifestyle';

const LifestyleContainer = ({ edit, create }) => (
  <DocumentLoader names={['msLifestyle']}>
    <DocumentProvider>
      <Lifestyle onStartEdit={edit} onCreate={create} />
    </DocumentProvider>
  </DocumentLoader>
);

LifestyleContainer.propTypes = {
  edit: PropTypes.func,
  create: PropTypes.func,
};

export default connect(null, { edit: actions.createCommit, create: actions.createDocumentAndCommit })(
  LifestyleContainer,
);
